import { registerPlugin } from '@capacitor/core';
const SecurePreferences = registerPlugin('SecurePreferences', {
    web: () => import('./web').then((m) => new m.SecurePreferencesWeb()),
});
export * from './definitions';
export { SecurePreferences };
//# sourceMappingURL=index.js.map